import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from '@/components/auth/AuthProvider';
import { Layout } from '@/components/layout/Layout';
import { Home } from '@/pages/Home';
import { Race } from '@/pages/Race';
import { RaceDashboard } from '@/pages/RaceDashboard';
import { RaceStats } from '@/pages/RaceStats';
import { Progress } from '@/pages/Progress';
import { AppProgress } from '@/pages/AppProgress';
import { AppDetail } from '@/pages/AppDetail';
import { ComingSoon } from '@/pages/ComingSoon';
import { AuthCallback } from '@/pages/AuthCallback';
import { Impressum } from '@/pages/legal/Impressum';
import { Privacy } from '@/pages/legal/Privacy';
import { Terms } from '@/pages/legal/Terms';
import { Support } from '@/pages/legal/Support';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="race" element={<RaceDashboard />} />
            <Route path="race/host" element={<Race />} />
            <Route path="race/:id" element={<RaceStats />} />
            <Route path="progress" element={<Progress />} />
            <Route path="progress/:appId" element={<AppProgress />} />
            <Route path="app/:appId" element={<AppDetail />} />
            <Route path="coming-soon" element={<ComingSoon />} />
            <Route path="impressum" element={<Impressum />} />
            <Route path="privacy" element={<Privacy />} />
            <Route path="terms" element={<Terms />} />
            <Route path="support" element={<Support />} />
          </Route>
          <Route path="auth/callback" element={<AuthCallback />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
